// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StockInstantaneos_container__HH6S5 {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-size: 16px;
}

.StockInstantaneos_container__HH6S5 .StockInstantaneos_header__A\\+OkE {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.StockInstantaneos_container__HH6S5 .StockInstantaneos_header__A\\+OkE .StockInstantaneos_titleContainer__X\\+eob {
  animation: StockInstantaneos_toright__\\+\\+uCL 0.3s;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.StockInstantaneos_container__HH6S5 .StockInstantaneos_header__A\\+OkE .StockInstantaneos_titleContainer__X\\+eob h4 {
  font-size: 1.6rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.StockInstantaneos_container__HH6S5 .StockInstantaneos_loader__r5FC1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
  height: 600px;
}

.StockInstantaneos_container__HH6S5 .StockInstantaneos_data__m3unX {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 300px;
}

/*---Información---*/
.StockInstantaneos_container__HH6S5 .StockInstantaneos_data__m3unX .StockInstantaneos_tableContainer__3ZtFt {
  animation: StockInstantaneos_toleft__-oyig 0.3s;
  border-radius: 5px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.StockInstantaneos_container__HH6S5 .StockInstantaneos_data__m3unX .StockInstantaneos_tableContainer__3ZtFt .StockInstantaneos_tableTitle__qATt1 {
  font-size: 0.9rem;
  font-weight: 500;
}

.StockInstantaneos_container__HH6S5 .StockInstantaneos_filters__w71t4 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.StockInstantaneos_container__HH6S5 .StockInstantaneos_filters__w71t4 .StockInstantaneos_item__OIIt1 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 30px;
  margin-right: 10px;
}

.StockInstantaneos_container__HH6S5 .StockInstantaneos_filters__w71t4 h4 {
  font-size: 1.3rem;
  font-weight: 300;
  margin-top: 0;
  animation: StockInstantaneos_toleft__-oyig 0.5s both;
}

.StockInstantaneos_container__HH6S5 .StockInstantaneos_filters__w71t4 .StockInstantaneos_loaderGames__8PYxQ {
  animation: StockInstantaneos_init__5RsiV 0.5s 0.2s both;
}

.StockInstantaneos_container__HH6S5 .StockInstantaneos_filters__w71t4 .StockInstantaneos_init1__jMx1Y {
  animation: StockInstantaneos_init__5RsiV 0.5s 0.2s both;
}
.StockInstantaneos_container__HH6S5 .StockInstantaneos_filters__w71t4 .StockInstantaneos_init2__7tWrS {
  animation: StockInstantaneos_init__5RsiV 0.5s 0.4s both;
}

.StockInstantaneos_container__HH6S5 .StockInstantaneos_options__RU-rh {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.StockInstantaneos_container__HH6S5 .StockInstantaneos_options__RU-rh p {
  margin: 0 0 0 10px;
  text-transform: capitalize;
  font-weight: 300;
}

@keyframes StockInstantaneos_init__5RsiV {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes StockInstantaneos_toright__\\+\\+uCL {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes StockInstantaneos_toleft__-oyig {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@media print {
  @page {
    size: landscape;
    margin: 20px 0 0;
    quotes: none;
    visibility: visible;
  }

  .StockInstantaneos_container__HH6S5 .StockInstantaneos_header__A\\+OkE {
    display: none !important;
  }

  .StockInstantaneos_container__HH6S5 .StockInstantaneos_filters__w71t4 {
    display: none !important;
  }

  .StockInstantaneos_container__HH6S5 .StockInstantaneos_data__m3unX {
    margin: 0;
    min-width: 99%;
  }

  .StockInstantaneos_container__HH6S5 .StockInstantaneos_data__m3unX .StockInstantaneos_tableContainer__3ZtFt {
    margin: 0;
    box-shadow: none;
    border-radius: 0;
  }

  .StockInstantaneos_tableTitle__qATt1 {
    color: black !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/StockInstantaneos/StockInstantaneos.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kDAAuB;EACvB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,+CAAsB;EACtB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,oDAA2B;AAC7B;;AAEA;EACE,uDAA8B;AAChC;;AAEA;EACE,uDAA8B;AAChC;AACA;EACE,uDAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".container {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  font-size: 16px;\n}\n\n.container .header {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  animation: toright 0.3s;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  font-size: 1.6rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.container .loader {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 50px;\n  height: 600px;\n}\n\n.container .data {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  min-height: 300px;\n}\n\n/*---Información---*/\n.container .data .tableContainer {\n  animation: toleft 0.3s;\n  border-radius: 5px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .data .tableContainer .tableTitle {\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.container .filters {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .filters .item {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-bottom: 30px;\n  margin-right: 10px;\n}\n\n.container .filters h4 {\n  font-size: 1.3rem;\n  font-weight: 300;\n  margin-top: 0;\n  animation: toleft 0.5s both;\n}\n\n.container .filters .loaderGames {\n  animation: init 0.5s 0.2s both;\n}\n\n.container .filters .init1 {\n  animation: init 0.5s 0.2s both;\n}\n.container .filters .init2 {\n  animation: init 0.5s 0.4s both;\n}\n\n.container .options {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.container .options p {\n  margin: 0 0 0 10px;\n  text-transform: capitalize;\n  font-weight: 300;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n    transform: translateY(50px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes toright {\n  0% {\n    opacity: 0;\n    transform: translateX(-100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes toleft {\n  0% {\n    opacity: 0;\n    transform: translateX(100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@media print {\n  @page {\n    size: landscape;\n    margin: 20px 0 0;\n    quotes: none;\n    visibility: visible;\n  }\n\n  .container .header {\n    display: none !important;\n  }\n\n  .container .filters {\n    display: none !important;\n  }\n\n  .container .data {\n    margin: 0;\n    min-width: 99%;\n  }\n\n  .container .data .tableContainer {\n    margin: 0;\n    box-shadow: none;\n    border-radius: 0;\n  }\n\n  .tableTitle {\n    color: black !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StockInstantaneos_container__HH6S5`,
	"header": `StockInstantaneos_header__A+OkE`,
	"titleContainer": `StockInstantaneos_titleContainer__X+eob`,
	"toright": `StockInstantaneos_toright__++uCL`,
	"loader": `StockInstantaneos_loader__r5FC1`,
	"data": `StockInstantaneos_data__m3unX`,
	"tableContainer": `StockInstantaneos_tableContainer__3ZtFt`,
	"toleft": `StockInstantaneos_toleft__-oyig`,
	"tableTitle": `StockInstantaneos_tableTitle__qATt1`,
	"filters": `StockInstantaneos_filters__w71t4`,
	"item": `StockInstantaneos_item__OIIt1`,
	"loaderGames": `StockInstantaneos_loaderGames__8PYxQ`,
	"init": `StockInstantaneos_init__5RsiV`,
	"init1": `StockInstantaneos_init1__jMx1Y`,
	"init2": `StockInstantaneos_init2__7tWrS`,
	"options": `StockInstantaneos_options__RU-rh`
};
export default ___CSS_LOADER_EXPORT___;
